import type { Notifications } from './types';

const title = 'Bluespine Management';

const email = 'hagay@bluespine.io';

const messages = {
  app: {
    unauthorized: {
      code: '401',
      title: 'Unauthorized',
      subTitle: 'You are not authorized to view this page',
    },
    notFound: {
      code: '404',
      title: 'Page Not Found',
      subTitle: 'The page you are looking for does not exist.',
    },
    crash: {
      code: '500',
      title: 'Internal Server Error',
      subTitle: 'Looks like something went wrong.',
      options: {
        email: `Contact support - ${email}`,
        reset: 'Press here to reload the application',
      },
    },
  },
  loader: {
    fail: 'There is something wrong with this component loading process... please retry or contact support',
  },
  images: {
    failed: 'Something went wrong during image loading',
  },
};

const notifications: Notifications = {
  options: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    autoHideDuration: 6000,
  },
  maxSnack: 4,
};

const loader = {
  // no more blinking in your app
  delay: 1000, // if your asynchronous process is finished during 300 milliseconds you will not see the loader at all
  minimumLoading: 700, // but if it appears, it will stay for at least 700 milliseconds
};

export { loader, notifications, messages, email, title };
